import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpOperatorSummaryFormatFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { ExpSummaryElementOptionsFactory } from "./ExpSummaryElementOptions";

/**
 * 
 * @export
 * @interface ExpOperatorSummaryFormat
 */

export class ExpOperatorSummaryFormatFactory {}
_ExpOperatorSummaryFormatFactory = ExpOperatorSummaryFormatFactory;
_defineProperty(ExpOperatorSummaryFormatFactory, "FromJSON", function (json) {
  return _ExpOperatorSummaryFormatFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpOperatorSummaryFormatFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'summaryType': json['summaryType'],
    'template': json['template'],
    'elementOptions': json['elementOptions'] === null || json['elementOptions'] === undefined ? json['elementOptions'] : Object.keys(json['elementOptions']).reduce((acc, key) => ({
      ...acc,
      [key]: ExpSummaryElementOptionsFactory.FromJSON(json['elementOptions'][key])
    }), {})
  };
});
_defineProperty(ExpOperatorSummaryFormatFactory, "ToJSON", function (value) {
  return _ExpOperatorSummaryFormatFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpOperatorSummaryFormatFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'summaryType': value.summaryType,
    'template': value.template,
    'elementOptions': value.elementOptions === undefined ? undefined : Object.keys(value.elementOptions).reduce((acc, key) => ({
      ...acc,
      [key]: ExpSummaryElementOptionsFactory.ToJSON(value.elementOptions[key])
    }), {})
  };
});
//# sourceMappingURL=ExpOperatorSummaryFormat.js.map
